/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const useEmailId = () => {
  const urlParams = new URLSearchParams(window.location.search);

  let schema = urlParams.get("schema");
  let email = urlParams.get("email");
  if (email) {
    email = String(email).trim();
  }
  if (schema) {
    schema = String(schema).trim();
  }

  return {
    email,
    schema
  };
};
